import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withNavItem } from 'react-skeletal-nav';

import Icon from 'wonderbly-components/lib/Icon';
import ActiveLink from '../../ActiveLink';

import logger from 'src/logger';
import './NavItem.scss';

/* eslint-disable react/jsx-no-bind, no-console */
const NavItemContent = ({ href, onClick, asTitle, children, handleActiveLink }) => {
  if (!!href) {
    return (
      <ActiveLink
        url={href}
        className="navigation__item__link"
        activeClassName="navigation__item__link--active"
        onActiveLink={handleActiveLink}>
        {children}
      </ActiveLink>
    );
  }

  let Tag = 'button';
  let className = 'navigation__item__button';

  if (asTitle) {
    Tag = 'h3';
    className = 'navigation__item__title text-kilo';
  }

  return (
    <Tag href={href} onClick={onClick} className={className}>
      {children}
    </Tag>
  );
};

const NavItem = withNavItem(({
  href,
  title,
  icon,
  route,
  children,
  onClick,
  isInRoute,
  asTitle,
  isActive,
  setActiveRoute,
}) => {
  const hasSubTree = !href && route !== 'root';
  if (hasSubTree) {
    useEffect(() => {
      logger.warn('Unable to have more then 1 level navigation');
    }, []);
    return null;
  }
  return (
    <li className={cx('navigation__item', {
      'navigation__item--open': isInRoute,
      'navigation__item--active': isActive,
    })}>
      <NavItemContent
        href={href}
        onClick={onClick}
        asTitle={asTitle}
        handleActiveLink={setActiveRoute}>
        {icon &&
          <Icon icon={icon} />
        }
        {title}
        {!!children &&
          <Icon icon={isInRoute ? 'directup' : 'dropdown'} />
        }
      </NavItemContent>
      {children}
    </li>
  );
});

NavItemContent.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

NavItem.propTypes = {
  ...NavItemContent.propTypes,
  icon: PropTypes.string,
  title: PropTypes.string,
};

export default NavItem;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Navigation/NavItem/NavItem.js